/**
 * User: nir
 * Date: 26/07/2016
 * Time: 14:07
 */
window.TCT = window.TCT || {};
window.TCT.isProduction = /^(the)?culturetrip\.com$/i.test(location.host);
window.TCT.debug = function () {
    if (TCT.isProduction) return;
    console.debug.apply(console, arguments);
};

window.TCT.warn = function () {
    console.warn.apply(console, arguments);
};

window.TCT.jQueryWarning = function () {
    console.warn('Module could not run because jQuery was not loaded');
};
